<template>
    <div>
        <section class="mainDet">
            <el-tabs v-loading="loading" v-model="activeName" type="card" :class="['cardTab',{'notabHead':resource == 0}]" ref="gsTable">
                <el-tab-pane label="会员信息" name="memberMsg">
                    <el-row class="memWrap">
                        <!--S 基本信息-->
                        <el-col :span="24" class="mg20">
                            <div class="grid-content">
                                <p class="commonTit"><b>基本信息</b></p>
                                <el-col :span="12">
                                    <ul class="basicWrap">
                                        <li>
                                            <em>头像：</em>
                                            <b class="avatar mgr10">
                                                <img class="imgAlign" :src="memberData.hpurl ? memberData.hpurl : 'https://presale.jhtsoft.com/picms/c47519dc61feb.png'"
                                                onerror="this.src='https://presale.jhtsoft.com/picms/c47519dc61feb.png'" >
                                            </b>
                                            <span class="iconstarsign" v-show="memberData.startmember==1&&ElementControls('open_start_order')==1" title="星标客户"></span>
                                            <el-tag v-if="this.showflows()" type="danger" plain effect="dark" v-show="memberData.ispredisprivilege==1" title="特惠码特权">特惠码</el-tag>
                                            <el-tag v-if="this.showflows()" type="warning" plain effect="dark" v-show="memberData.ishvipprivilege==1" title="HVIP特权">HVIP</el-tag>
                                        </li>
                                        <li>
                                            <em>昵称：</em>
                                            <b>
                                                <strong class="moreText">{{memberData.nickname || '--'}}</strong>
                                                <i v-if="memberData.sex != 2" :class="[{'iconfemale':memberData.sex == 1},{'iconmale':memberData.sex == 0}]"></i>
                                            </b>
                                        </li>
                                        <li>
                                            <em>会员账号：</em>
                                            <b class="moreText">{{memberData.username || '--'}}</b>
                                        </li>
                                        <li>
                                            <em>会员级别：</em>
                                            <b>{{memberData.mlevelname || '--'}}</b>
                                        </li>
                                        <li class="flexUI rulrMemo">
                                            <em>所在分组：</em>
                                            <b>{{groupinfo || '--'}}</b>
                                        </li>
                                        <!-- <li>
                                            <em>会员使用范围：</em>
                                            <b>内部使用</b>
                                        </li> -->
                                    </ul>
                                </el-col>
                                <el-col :span="12">
                                    <ul class="basicWrap">
                                        <li>
                                            <em>手机号码：</em>
                                            <b>{{memberData.mphone || '--'}}</b>
                                        </li>
                                        <li class="flexUI rulrMemo">
                                            <em>详细地址：</em>
                                            <b>{{memberData.province || '--'}} {{memberData.city}} {{memberData.district}} {{memberData.addrdet}}</b>
                                        </li>
                                        <li>
                                            <em>邮箱：</em>
                                            <b>{{memberData.email || '--'}}</b>
                                        </li>
                                        <li>
                                            <em>注册时间：</em>
                                            <b>{{dateTime(memberData.regdate, 1)}}</b>
                                        </li>
                                        <li>
                                            <em>注册方式：</em>
                                            <b>{{memberData.regway == 0 ? '微信自动注册' : memberData.regway == 1 ? '自定义账号注册' : '企业内部注册'}}</b>
                                        </li>
                                        <li class="flexUI rulrMemo">
                                            <em>备注：</em>
                                            <b>{{memberData.memo || '--'}}</b>
                                        </li>
                                    </ul>
                                </el-col>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <div class="grid-content">
                                <p class="commonTit"><b>会员资产</b></p>
                                <ul class="basicWrap">
                                    <li>
                                        <em>商城币余额：</em>
                                        <b class="priceFont"><i>￥</i>{{memberData.rbalance | formatAmount}}</b>
                                    </li>
                                    <li>
                                        <em>现金余额：</em>
                                        <b class="priceFont"><i>￥</i>{{memberData.cbalance| formatAmount}}</b>
                                    </li>
                                    <li>
                                        <em>积分余额：</em>
                                        <b class="priceFont">{{memberData.ibalance || 0}}</b>
                                        <a class="blueColor popBtn" href="javascript:;" @click="getRecordShow()">积分变更记录</a>
                                    </li>
                                </ul>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="资产变更记录" name="assetChangeRecordTab">
                    <div class="memWrap">
                        <!--S 检索-->
                        <el-form :inline="true" :model="getAllMarDetailForm">
                            <el-form-item label="明细类型" class="formTimeSlot">
                                <el-select v-model="getAllMarDetailForm.type" placeholder="请选择" clearable>
                                <el-option label="收入" value="0"></el-option>
                                <el-option label="消费" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="渠道" class="formTimeSlot">
                                <el-select v-model="getAllMarDetailForm.source" placeholder="请选择" clearable>
                                <el-option label="券卡提货" value="0"></el-option>
                                <el-option label="商城购买" value="1"></el-option>
                                <el-option label="商品溯源" value="2"></el-option>
                                <el-option label="营销活动" value="3"></el-option>
                                <el-option label="分享返利" value="4"></el-option>
                                <el-option label="消费卡充值" value="5"></el-option>
                                <el-option label="会员签到" value="6"></el-option>
                                <el-option label="积分兑换" value="7"></el-option>
                                <el-option label="订单取消" value="8"></el-option>
                                <el-option label="商品评价" value="9"></el-option>
                                <el-option label="新人礼包" value="10"></el-option>
                                <el-option label="余额提现" value="11"></el-option>
                                <el-option label="商家后台操作" value="12"></el-option>
                                <el-option label="线下购买" value="13"></el-option>
                                <el-option label="兑换商城币" value="14"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="创建时间">
                                <el-date-picker
                                    v-model="getAllMarDetailForm.date"
                                    type="daterange"
                                    :picker-options="pickerOptions"
                                    range-separator="至"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间"
                                    value-format="yyyy-MM-dd"
                                    align="left">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getAllMarDetailList">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!--E 检索-->
                    <el-table ref="cvTable" :data="balanceData" class="orderTable comTable" border v-loading="vloading"
                        :maxHeight="tableHeight" :key="'mallCoinsTab'">
                        <el-table-column type="index" label="序号" fixed></el-table-column>
                        <el-table-column label="渠道来源" min-width="150">
                            <template slot-scope="scope">
                                <span>{{scope.row.source | sourcefiter}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="数量" min-width="150">
                            <template slot-scope="scope">
                                <h3 :class="scope.row.type==0?'greenColor':'redColor'">{{scope.row.type==0?'+':'-'}}{{scope.row.amount}}
                                </h3>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作时间" min-width="180">
                            <template slot-scope="scope">
                                <span>{{dateTime(scope.row.credate,1) || '--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作备注" min-width="240">
                            <template slot-scope="scope">
                                <span>{{scope.row.memo || '--'}}</span>
                                <p @click="openRelationPop(scope.row)" v-if="scope.row.relcode&&(scope.row.source== 0 || scope.row.source== 1 || scope.row.source== 5 || scope.row.source== 8 || scope.row.source== 14)">
                                    查看 <span class="cursorHand priceFont"><i class="iconhand"></i>{{ scope.row.relcode }}</span>
                                </p>
                            </template>
                        </el-table-column>
                        <template slot="empty">
                            <div class="noData"><span>暂无数据</span></div>
                        </template>
                    </el-table>
                    <!-- S 分页 -->
                    <Page :pageTotal="getAllMarDetailForm.pagetotal" :currentPage="getAllMarDetailForm.currentpage"  :pageSize="getAllMarDetailForm.pagesize"  @nowPageParam="updatePageParams"></Page>
                    <!-- E 分页 -->
                </el-tab-pane>
            </el-tabs>
            <div class="bottomBtn">
                <el-button @click="$router.back(-1)" type="primary">返回列表</el-button>
            </div>
        </section>
        <!--S 订单详情组件-->
        <OrderDetail :orderno="relcode" :orderDetailBox="orderDetailShow" @closeODBox="orderDetailShow = false"></OrderDetail>
        <!--E 订单详情组件组件-->
        <!-- S 出库详情弹框 -->
		 <!-- 券卡详情 -->
        <!-- <OutDetail :cardInfo="cardInfo"  :outDetailDialogVisible="outDetailDialogVisible"  @closeChild="getCloseOutDetailCld"></OutDetail> -->
        <!-- E 出库详情弹框 -->
        <!-- 券卡详情 -->
        <CardsMsg v-if="cardsMsgDialogVisible" :codeInfo="cardInfo" :cardsMsgDialogVisible="cardsMsgDialogVisible"  @closeChild="getCloseOutDetailCld"></CardsMsg>
        <!-- E 券卡详情弹框 -->
        <!-- S 消费卡出库详情 -->
        <CardOrCouponDetail :codeinfo="cardInfo" :couponinfo="couponInfo" :cardsType="couponInfo?'优惠券':'消费卡'" :infos="infos" :cardOrCouponDetailDlog="cardOrCouponDetailDlog"  @closeChild="getCloseOutDetailCld"></CardOrCouponDetail>
        <!-- E 消费卡出库详情 -->
		<!-- S 积分变更记录弹窗 -->
        <el-dialog :visible.sync="recordShow" class="comDlog groupMdg" :before-close="getRecordClose" append-to-body :close-on-click-modal="false">
            <div slot="title" class="dialog-title">积分变更记录</div>
            <el-form :model="recordForm" :inline="true" class="searchForm">
                <el-form-item label="明细类型" class="formTimeSlot">
                    <el-select v-model="recordForm.type" placeholder="请选择" clearable>
                        <el-option label="收入" value="0"></el-option>
                        <el-option label="消费" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道" class="formTimeSlot">
                    <el-select v-model="recordForm.source" placeholder="请选择" clearable>
                        <el-option label="券卡提货" value="0"></el-option>
                        <el-option label="商城购买" value="1"></el-option>
                        <el-option label="商品溯源" value="2"></el-option>
                        <el-option label="营销活动" value="3"></el-option>
                        <el-option label="分享返利" value="4"></el-option>
                        <el-option label="消费卡充值" value="5"></el-option>
                        <el-option label="会员签到" value="6"></el-option>
                        <el-option label="积分兑换" value="7"></el-option>
                        <el-option label="订单取消" value="8"></el-option>
                        <el-option label="商品评价" value="9"></el-option>
                        <el-option label="新人礼包" value="10"></el-option>
                        <el-option label="余额提现" value="11"></el-option>
                        <el-option label="商家后台操作" value="12"></el-option>
                        <el-option label="线下购买" v-if="showflows()" value="13"></el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="创建时间">
                    <el-date-picker
                      v-model="recordForm.servetime"
                      type="daterange"
                      :picker-options="pickerOptions"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd"
                      align="left">
                    </el-date-picker>
                  </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="serch">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loadings" class="comTable" ref="tables" border :data="getMardetailList" maxHeight="450">
                <el-table-column label="序号" width="60" type="index">
                </el-table-column>
                <el-table-column label="渠道" sortable prop="groupname">
                    <template slot-scope="scope">
                        <p class="textHiden">{{ scope.row.source |sourcefiter }}</p>
                        <small class="greyColor">{{dateTime(scope.row.credate,1)}}</small>
                    </template>
                </el-table-column>
                <el-table-column label="数量" sortable prop="bwxgroup">
                    <template slot-scope="scope">
                        <em :class="[{'greenColor':scope.row.type==0},{'redColor':scope.row.type==1}]">{{scope.row.type==0?'+':'-'}}{{scope.row.amount}}</em>
                    </template>
                </el-table-column>
                <el-table-column label="变更说明">
                    <template slot-scope="scope">
                        <p class="textFl" :title="scope.row.memo||''">{{scope.row.memo||'--'}}</p>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <!-- S 分页 -->
            <Page :pageTotal="pagebean1.pagetotal" :currentPage="pagebean1.currentpage"  :pageSize="pagebean1.pagesize"  @nowPageParam="setPageparam1"></Page>
            <!-- S 分页 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="getRecordClose(1)">关闭</el-button>
            </div>
        </el-dialog>
        <!-- E 积分变更记录弹窗 -->

    </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '../../../apis/api';
export default {
    name: 'MemberDetail',
    data () {
        let that =this;
        return {
            expecttitle: localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : '',
            groupinfo: '',//会员分组信息
            codetypeLists: [
                { label: "礼品券卡", value: "0" },
                { label: "消费卡", value: "1" }
            ],
            cardmediumLists: [
                { label: "电子券卡", value: "1" },
                { label: "实体券卡", value: "0" }
            ],
            stateLists: [
                { label: "未使用", value: "0" },
                { label: "已使用", value: "1" }
            ],
            delimodeLists: [
                { label: '自提', value: "0" },
                { label: '送货', value: "1" }
            ],
            ordertypeLists: [
                { label: '券卡提货', value: "0" },
                { label: '商城购买', value: "1" },
            ],
            deliverstateLists: [
                { label: '待发货', value: "0" },
                { label: '已发货', value: "1" },
                { label: '退货', value: "2" },
                { label: '已补发', value: "3" },
                { label: "已签收", value: "5" },
                { label: "异常签收", value: "6" },
            ],
            loading: false,
            cardInfo: '', // 传递的券卡信息
            memberCode: '', // 会员的编号
            resource:0,//1:注册会员，0：微信粉丝
            activeName:'memberMsg',//大tab选中子项
            addRedVisible:false,//增加商城币余额
            reduceRedVisible:false,//减少商城币余额
            addRedForm:{
                addVal:'',
                reduceVal:'',
                addNotice:"",//积分变更说明 +
            },//加减商城币余额表单
            addIntegralVisible:false,//增加商城积分余额
            reduceIntegralVisible:false,//增加商城积分余额
            addIntegralForm:{
                addVal:'',
                reduceVal:'',
            },//加减商城积分余额表单
            tableHeight: window.innerHeight * 0.8, //表格动态高度
            ticketHeight: window.innerHeight * 0.8, //表格动态高度
            shipHeight: window.innerHeight * 0.8, //表格动态高度
            isMore:false,//订单信息是否高级筛选
            memberData: {},//会员详情信息
            orderDetailShow:false, //订单详情
            outDetailDialogVisible:false,//出库详情弹框
            cardOrCouponDetailDlog:false,// 消费卡出库详情弹框
            couponInfo: '', // 优惠券信息
            infos: '', // 消费卡/优惠券卡包信息
            cardsMsgDialogVisible: false, // 券卡出库详情弹窗
            cardData:[],//券卡信息列表
            imageUrl: '',//头像图片
            groupList:[
                { value: "0", label: "星标组" },
                { value: "1", label: "分组一" },
                { value: "2", label: "分组二" }
            ],//分组
            pickerOptions:{
                shortcuts: [
                    {
                    text: "今天",
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime());
                        picker.$emit("pick", [start, end]);
                    }
                    },
                    {
                    text: "最近一周",
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit("pick", [start, end]);
                    }
                    },
                    {
                    text: "最近一个月",
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit("pick", [start, end]);
                    }
                    },
                    {
                    text: "最近三个月",
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit("pick", [start, end]);
                    }
                    }
                ]
            },//时间选择
            membercode: '',//会员编号
            recordShow:false,//变更记录弹窗
            recordForm:{//变更记录检索弹窗
                martype:'',
                type:'',
                source:'',
                servetime:[],
            },
            pagebean1: {
                pagesize: 30,
                currentpage: 1,
                pagetotal: 0,
            },//分页
            getMardetailList:[],
            loadings:false,
            collectLikesShow:false,//集赞参与信息弹窗
            // 集赞参与信息
            registerForm:{
                types:1,//类型
                numse:"",//数量
                notice:"",//说明
            },
            getOrderin:'',
            balanceData:[],//资产变更明细
            vloading:false,//
            getAllMarDetailForm:{
              martype:1,//营销类型 0：积分 1：商城红包 2：佣金
              type:'0',// 0：收入 1：消费
              source:'',
              date:'',
              pagesize: 30,
              currentpage: 1,
              pagetotal: 0,
            },
            // 查看记录关联的券卡或订单信息 zys 2024/12/16 S
            relcode: '', // 记录关联的编号 有可能是订单号或者券卡编码
            // 查看记录关联的券卡或订单信息 zys 2024/12/16 E
        }
    },
    filters:{
        sourcefiter(val){
          if(val == 0){
                return '券卡提货'
            }else if(val == 1){
                return '商城购买'
            }else if(val == 2){
                return '商品溯源'
            }else if(val == 3){
                return '营销活动'
            }else if(val == 4){
                return '分享返利'
            }else if(val == 5){
                return '消费卡充值'
            }else if(val == 6){
                return '会员签到'
            }else if(val == 7){
                return '积分兑换'
            }else if(val == 8){
                return '订单取消'
            }else if(val == 9){
                return '商品评价'
            }else if(val == 10){
                return '新人礼包'
            }else if(val == 11){
                return '余额提现'
            }else if(val == 12){
                return '商家后台操作'
            }else if(val == 13){
                return '线下购买'
            }else if(val == 14){
              return '兑换商城币'
            }
        },
        // 券卡当前状态
        stateFilter(val){
            if(val == 0){
                return '未激活'
            }else if(val == 1){
                return '未提货'
            }else if(val == 2){
                return '部分提货'
            }else if(val == 3){
                return '已提货'
            }else if(val == 4){
                return '暂停提货'
            }else if(val == 5){
                return '已回收'
            }else if(val == 6){
                return '已作废'
            }else if(val == 8){
                return '回收折现'
            }
        },
        // 编码类型
        codetypeFilter(val){
            if(val == 0){
                return '兑换礼券'
            }else if(val == 1){
                return '消费卡'
            }
        },
        // 券卡介质
        cardmediumFilter(val){
            if(val == 0){
                return '实体券卡'
            }else if(val == 1){
                return '电子券卡'
            }
        },
    },
    watch:{
        // 监听tab切换
        activeName(){
            if(this.activeName == 'assetChangeRecordTab'){
              this.getAllMarDetailList()
            }
        },
    },
    components: {
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
        OrderDetail: resolve => require(["@/components/common/OrderDetail.vue"], resolve), //查看订单详情组件
        OutDetail: resolve => require(["@/components/CardsFolder/OutDetail.vue"], resolve),//出库详情弹框
        CardsMsg: resolve => require(["@/components/CardsFolder/CardsMsg.vue"], resolve),//券卡详情弹框
        CardOrCouponDetail: resolve => require(["@/components/CardsFolder/CardOrCouponDetail.vue"], resolve),//消费卡/优惠券出库详情弹框
    },
    // ====================================== 方法 ======================================
    methods:{
        // 查看记录关联的券卡或订单信息 zys 2024/12/16 S
        openRelationPop(row) {
            this.relcode = row.relcode;
            if(row.source== 0 || row.source== 1 || row.source== 8) {
                // 打开订单详情弹窗
                this.orderDetailShow = true;
            } else {
                // 打开出库详情弹框
                this.getCoverDetailShow(this.relcode,1);
            }
        },
        // 查看记录关联的券卡或订单信息 zys 2024/12/16 E
        getOrderinfoList(){
            let param ={
            orderucode:this.membercode,
            ordertype:7,
            gtype:0,
            pageparam:{
                pagesize:1,
                currentpage: 1
                }
            }
            api.GET_ORDERLIST(param).then(res =>{
                if(res.data.status=="200"&&res.data.data&&res.data.data.length>0){
                    this.getOrderin = res.data.data[0]
                }else{
                    this.getOrderin =''
                }
            })
        },
        twoDateReceive1(val) {
            if(val){
                this.jizanform.sdate = this.dateTime(val[0],1);
                this.jizanform.edate = this.dateTime(val[1],1);
            }else{
                this.jizanform.sdate = '';
                this.jizanform.edate = '';
            }
        },
        serch(){
            this.MardetailList()
        },
        setPageparam1(nowPageSize, nowCurrentPage) {
            if(nowPageSize) {
                this.pagebean1.pagesize = nowPageSize
            }
            if(nowCurrentPage) {
                this.pagebean1.currentpage = nowCurrentPage
            }
            this.MardetailList()
        },
        // 打开积分变更记录弹窗
        getRecordShow(){
            this.recordForm={//变更记录检索弹窗
                martype:'',
                type:'',
                source:'',
                servetime:[],
            };
            this.pagebean1={
                pagesize: 30,
                currentpage: 1,
                pagetotal: 0,
            };
            this.MardetailList()
            this.recordShow = true;
        },
        MardetailList(){
            this.loadings = true
            let param = {
                membercode:this.membercode,
                type:this.recordForm.type,
                martype:0,
                source:this.recordForm.source,
                startdate:this.recordForm.servetime&&this.recordForm.servetime.length>0?this.recordForm.servetime[0]+' 00:00:00':'',
                enddate:this.recordForm.servetime&&this.recordForm.servetime.length>0?this.recordForm.servetime[1]+' 23:59:59':'',
                pageparam:{
                pagesize: this.pagebean1.pagesize,
                    currentpage: this.pagebean1.currentpage,
                }
            }
            api.GET_MARDETAILLIST(param).then(res =>{
                if(res.data.status=="200"&&res.data.data!=null){
                    this.getMardetailList = res.data.data;
                    this.pagebean1.pagetotal = res.data.pagebean.totalnum;
                    this.toTableTop('tables')
                    this.loadings = false;
                }else{
                    this.getMardetailList = [];
                    this.loadings = false;
                }
            }).catch((err)=>{
                this.getMardetailList = [];
                this.loadings = false;
            })
        },
        // 关闭积分变更记录弹窗
        getRecordClose(){
            this.recordShow = false;
            this.collectLikesShow=false
        },
        // 打开出库详情弹框
        getCoverDetailShow(code,type){
            api.GET_CARDINFODET({code: code}).then(res =>{
                if(res.data.status=="200"){
                  if(res.data.data.codeinfo){
                    this.cardInfo = res.data.data.codeinfo;
                    if(type!=1) {
                        this.outDetailDialogVisible = true;
                    } else {
                        if(this.cardInfo.codetype==1) {
                            this.couponInfo = '';
                            this.infos = this.cardInfo.cardBagInfo;
                            this.cardOrCouponDetailDlog = true;
                        } else {
                            this.cardsMsgDialogVisible = true;
                        }
                    }
                  } else if(res.data.data.couponinfo) {
                    this.couponInfo = res.data.data.couponinfo;
                    this.infos = this.couponinfo.cardBagInfo;
                    this.cardOrCouponDetailDlog = true;
                  }
               }
            })
        },
        // 关闭出库详情弹框
        getCloseOutDetailCld(){
            this.outDetailDialogVisible = false;
            this.cardOrCouponDetailDlog = false;
            this.cardsMsgDialogVisible = false;
        },
        //获取会员详情
        getMemberDetail() {
            this.loading = true
            api.GET_MEMBERDETAIL({membercode: this.membercode}).then(res => {
                if (res.data.status == '200') {
                    this.memberData = res.data.data;
                } else {
                    this.memberData = {}
                }
                this.getMemberGroupList()
                this.loading = false
            }).catch(() => {this.loading = false})
        },

        //获取会员分组列表
        getMemberGroupList() {
            this.loading = true
            let params = {
                membercode: this.membercode,
            }
            api.GET_GROUPLIST(params).then(res => {
                if (res.data.status == '200') {
                    this.groupinfo = ''
                    res.data.data.forEach(element => {
                        this.groupinfo += element.groupname + '，'
                    })
                    this.groupinfo = this.groupinfo.substring(0, this.groupinfo.length - 1)
                }
                this.loading = false
            }).catch(() => {this.loading = false})
        },
        // S 会员详情-资产变更明细
        getAllMarDetailList(){
            this.vloading = true
            let param = {
                membercode: this.membercode,
                martype:this.getAllMarDetailForm.martype,
                source:this.getAllMarDetailForm.source,
                startdate:this.getAllMarDetailForm.date&&this.getAllMarDetailForm.date.length>0?this.getAllMarDetailForm.date[0]+' 00:00:00':'',
                enddate:this.getAllMarDetailForm.date&&this.getAllMarDetailForm.date.length>0?this.getAllMarDetailForm.date[1]+' 23:59:59':'',
                pageparam:{
                    pagesize: this.getAllMarDetailForm.pagesize,
                    currentpage: this.getAllMarDetailForm.currentpage,
                }
            }
            if(this.getAllMarDetailForm.type!=''){
                param.type = this.getAllMarDetailForm.type
            }
            api.GET_MARDETAILLIST(param).then(res =>{
                if(res.data.status=="200"&&res.data.data!=null){
                    this.balanceData = res.data.data;
                    this.getAllMarDetailForm.pagetotal = res.data.pagebean.totalnum;
                    this.vloading = false;
                }else{
                    this.balanceData = [];
                    this.vloading = false;
                }
            }).catch((err)=>{
                this.balanceData = [];
                this.vloading = false;
            })
        },
        updatePageParams(nowPageSize, nowCurrentPage) {
            if(nowPageSize) {
                this.getAllMarDetailForm.pagesize = nowPageSize
            }
            if(nowCurrentPage) {
                this.getAllMarDetailForm.currentpage = nowCurrentPage
            }
            this.getAllMarDetailList()
        },
        // E 会员详情-资产变更明细
    },
    // ==================================== 生命周期 ====================================
    mounted () {
        if(this.showflows()){
            this.ordertypeLists.push({ label: '线下购买', value: "7" })
        }
        if (this.$route.params) {
            this.resource = this.$route.params.resource
            this.membercode = this.$route.params.membercode
        }
        this.getMemberDetail()

    },
    created() {
    },
    destroyed(){
    }
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.mainDet{
    padding: 20px 20px 70px;
    height: calc(100% - 50px);
}
.mainDet >>> .cardTab > .el-tabs__header{
    position: fixed;
    z-index: 19;
    top: 50px;
    left: 194px;
    width: calc(100% - 454px);
    padding: 20px 0 0 0;
    background: #fff;
    -webkit-transition: all .3s;
    transition: all .3s;
}
.helpRight .mainDet >>> .cardTab > .el-tabs__header{
    width: calc(100% - 220px);
}
.takeLeft.helpRight .mainDet >>> .cardTab > .el-tabs__header{
    width: calc(100% - 70px);
}
.takeLeft .mainDet >>> .cardTab > .el-tabs__header{
    left: 40px;
    width: calc(100% - 300px);
}
.memWrap{
    margin-top: 60px;
}
.memWrap .commonTit{
    margin-bottom: 20px;
}
.memWrap .el-col-24{
    margin-bottom: 20px;
}
/* S 会员信息 */
.memberTab>>>.el-tabs__header{
    margin-bottom: 20px;
    position: relative;
    left: 0;
    top: 0;
}
.avatar{
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid #ebeef5;
    overflow: hidden;
    position: relative;
    display: inline-block;
    vertical-align: middle;
}
.basicWrap li,
.statisticsWrap li p{
    margin: 20px 0;
}
.basicWrap li:first-child{
    margin-top: 0;
}
.basicWrap li em,
.statisticsWrap li em{
    color: #333;
    width: 100px;
    display: inline-block;
    text-align: right;
}
.basicWrap li b,
.statisticsWrap li b{
    color: #999;
}
.basicWrap li b.priceFont,
.statisticsWrap li b.priceFont{
    color: #333;
}
.basicWrap li b i{
    font-size: 18px;
    vertical-align: top;
}
.rulrMemo b{
    width: calc(100% - 100px);
}
.statisticsWrap li{
    background: #fafafa;
    padding: 15px;
    margin-right: 20px;
    height: 140px;
    width: calc((100% - 60px) / 4);
}
.statisticsWrap li:last-child{
    margin-right: 0;
}
.statisticsWrap li h3{
    font-size: 14px!important;
    color: #333;
    font-weight: bold;
    margin-bottom:15px ;
}
.moreText{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 130px);
    display: inline-block;
    vertical-align: text-top;
}
.popBtn{
    margin-left: 10px;
}
.popBtn .el-button{
    padding: 0;
    width: 22px;
    height: 22px;
}
.center{text-align: center;}
.addItem .el-input-group,
.addItem .el-input{
    width: 145px;
    margin: 0 5px;
}
.addItem >>> .el-input-group__prepend{
    padding: 0 10px;
}

.groupMdg >>> .el-dialog {width:900px;}
/* E 会员信息 */
/* S 订单表格 */
.none{display: none;}
.block{display: block;}
@media(max-width:1380px){
    .orderForm>>>.el-input{
        width: 120px;
    }
    .orderForm>>>.el-range-editor{
        width: 240px;
    }
}
@media(min-width:1380px) and (max-width:1680px){
    .orderForm>>>.el-input{
        width: 150px;
    }
    .orderForm>>>.el-range-editor{
        width: 240px;
    }
}
.smallSlt>>>.el-input {width: 80px;}
.simpleSearch{line-height: 40px;color: var(--main-color);cursor: pointer;white-space: nowrap;}
.orderTable {position: relative; height: 100%;}
.orderTable small {display:block; color:#999;}
.orderTable .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.priceFont em{font-size: 14px; font-weight: 400;}
.shouMsg strong{border: 1px solid #3c9bfa; border-radius: 10px;padding: 0 6px; font-weight: bold;}
.shouMsg strong.blueColor {border-color:#3c9bfa;}
.shouMsg strong.orangeColor {border-color:#FF7018;}
.orderContentI i{font-size: 18px;}

.haveChildOd p {line-height:18px;}
.haveChildOd .iconadd2 {font-size: 18px; color:var(--main-color);vertical-align: top; cursor: pointer}
.dateSource{
  line-height: 25px;
}
.dateSource small{
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 50px);
}
.dateSource strong{
  font-weight: bold;
}
/* E 订单表格 */
.CheckBold{
  font-weight:bold;
  color:#333;
  cursor:pointer;
}
.deliveryNum i{
  color:#999;
  margin-left:5px;
}
/*微信粉丝会员独有*/
/*会员详情样式重置 start*/
.mainDet >>> .notabHead > .el-tabs__header,
.mainDet >>> .notabHead > .el-tabs__header .el-tabs__item:not(:first-child),
.mainDet >>> .notabHead > .el-tabs__content .el-tab-pane:not(:first-child) {display:none;}
.mainDet >>> .notabHead > .el-tabs__content {margin-top:-70px;}
/*会员详情样式重置 end*/

.mgr10{margin-right: 10px;}
.mb10{margin-bottom: 10px;}
.pdt60{padding-top: 60px;}
.myComDlog .pb10{padding: 0 10px 10px;}
/* 线下购买记录样式 */
.discount>>>.el-form-item__content{display: flex;align-items: center;}
.discount .discount1{width: 30%;}
.discount .discount1 >>> .el-input__inner{padding: 0 10px;}
.discount .discount2{width: calc(70% - 10px);margin-left: 10px;}

/* 集赞参与信息弹窗 */
.myComDlog >>> .el-dialog{width: 1400px;}
.myComDlog >>> .el-dialog__body{max-height: 700px;}
.myComDlog .commonTit{margin:10px 0;}
.bgfa{background: #fafafa;padding: 0 10px;}
.titleDetail,.titleRegister >>> .el-form-item__label{font-weight: bold;font-size: 16px;}
.titleRegister{margin-bottom: 0;}
.titleDetail{line-height: 40px;}

.shureAndreset{padding-bottom: 5px;}

/* 积分变更悬浮框 */
.myFormAddReduce >>> .addItem .el-form-item__content{max-width: 244px;}
.myFormAddReduce >>> .el-form-item__content .el-input{width: 100%;}

.pdt60 .commonForm {margin-top:30px;}

.recentlyBox{width: 30%; min-width:300px; margin-top: 30px; margin-left:50px; padding: 1rem;background: #fafafa;}
.recentlyBox h4{font-size: 16px;font-weight: bold;}
.recentlyBox li{margin:1rem 0;display: flex;align-items: flex-start;}
.recentlyBox li em{width: 140px;}
.recentlyBox li b{width: calc(100% - 140px);}

.iconstarsign{ font-size: 30px; color: #FFAE48;margin-right:5px;vertical-align: middle;}
.priceFont .iconhand:before {margin-right: 10px;font-size: 20px; vertical-align: top; font-weight: normal!important;}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/MemberDetail.vue